import React from 'react';
import styled from 'styled-components';
import { withTextSkeleton, withCircleSkeleton } from '@cld/skeleton';

const TextWithSkeleton = withTextSkeleton(styled.span``);

const Wrapper = styled.div`
  width: 100% !important;
  height: 80% !important;
  > div:first-child {
    margin-right: 7px;
  }
`;

const CircleWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: 18px !important;
  height: 18px !important;
`;

const TextWrapper = styled.div`
  height: 10px !important;
  width: 80% !important;
`;

const FolderIconWithSkeleton = withCircleSkeleton(styled.span``);

const FolderItemSkeleton = () => (
  <Wrapper>
    <CircleWrapper>
      <FolderIconWithSkeleton isLoading />
    </CircleWrapper>
    <TextWrapper>
      <TextWithSkeleton isLoading />
    </TextWrapper>
  </Wrapper>
);

export default FolderItemSkeleton;
